import { Localization, initLocalizations, t, Locales } from './localization';

export { initLocalizations, t, Localization, Locales };
